const website = document.querySelector('.website');
const hamburgerOpen = document.querySelector('#hamburger-open');
const hamburgerClose = document.querySelector('#hamburger-close');
const menus = document.querySelector('#header-menus');
const menuLinks = menus.querySelectorAll('.header-menu a');

function linkCloseMenu() {
	menuLinks.forEach(menuLink => {
		menuLink.addEventListener('click', () => {
			menus.close();
			website.classList.remove('website--hamburger-open');
		});
	});
}

hamburgerOpen.addEventListener('click', () => {
	menus.showModal();
	website.classList.add('website--hamburger-open');
});

hamburgerClose.addEventListener('click', () => {
	menus.close();
	website.classList.remove('website--hamburger-open');
});

/* Open menu on desktop, close it on mobile */
const mediaQuery = window.matchMedia('(min-width: 992px)');

mediaQuery.addEventListener('change', (e) => {
	if (e.matches) {
		menus.close();
		menus.show();
	} else {
		menus.close();
		website.classList.remove('website--hamburger-open');
	}
});

if (mediaQuery.matches) {
	menus.show();
	document.activeElement.blur();
} else {
	menus.close();
	website.classList.remove('website--hamburger-open');
	linkCloseMenu();
}